import { StylesConfig } from 'react-select';

import { Colors } from 'appConstants';
import { SelectOption } from 'types';

export const createTicketCustomStyles: StylesConfig<SelectOption<string>, false> = {
  valueContainer: (provided) => ({
    ...provided,
    height: 64,
    minWidth: 160,
    padding: 20,
    borderRadius: 24,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: Colors.TEXT_COLOR,
    fontWeight: 500,
    fontSize: 14,
    textAlign: 'left',
  }),

  placeholder: (provided) => ({
    ...provided,
    color: Colors.TEXT_COLOR,
    fontWeight: 500,
    fontSize: 14,
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: Colors.GRAY,
    borderRadius: 24,
    boxShadow: 'none',
    ':hover': { borderColor: Colors.GRAY2 },
    marginBottom: 16,
    border: 'none',
  }),

};
